import {IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, IFilterOption} from "../models";
import { GET_FILTERS_START, GET_FILTERS_END, CHANGE_FILTER, getFilters, Actions } from "../actions";

export function filterOptionsReducer(state: IFundFilterResponse & IShareClassFilterResponse = {  }, action: Actions) {
	function clearSelections() {
		for (let key of Object.keys(state)) {
			for (let filterOption of state[key] as IFilterOption[]) {
				filterOption.selected = false;
			}
		}
	}
	switch (action.type) {
		case CHANGE_FILTER:
			if (action && action.payload && state) {
				let options = action.payload as IFilterRequest;
				clearSelections();
				if (options.search && options.search.length > 0) {
					for (let searchOption of options.search) {
						let filterOptions = state[searchOption.property];
						if (filterOptions) {
							for (let filterOption of filterOptions.filter(i => searchOption.values.indexOf(i.value) > -1)) {
								filterOption.selected = true;
							}
						}
					}
				}
			}

			return Object.assign({}, state);
        case GET_FILTERS_END:
			return action.payload || {};
		default: return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/filterOptions.ts